import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { StoreProvider, useStore } from './context/StoreContext';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import ConnectAccount from './pages/ConnectAccount';
import License from './pages/License';

// Component to apply dark mode class
function DarkModeWrapper({ children }) {
  const { isDarkMode } = useStore();
  
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);
  
  return children;
}

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isLicenseValid } = useStore();
  
  if (!isLicenseValid) {
    return <Navigate to="/license" replace />;
  }
  
  return children;
};

// App Routes
function AppRoutes() {
  return (
    <Routes>
      {/* Landing page - public entry point */}
      <Route path="/" element={<Landing />} />
      
      {/* License page - needs license verification */}
      <Route path="/license" element={<License />} />
      
      {/* Connect account - protected - needs license and account */}
      <Route 
        path="/connect" 
        element={
          <ProtectedRoute>
            <ConnectAccount />
          </ProtectedRoute>
        } 
      />
      
      {/* Dashboard - protected */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      
      {/* Default redirect to landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// Main App Component
function App() {
  return (
    <StoreProvider>
      <DarkModeWrapper>
        <Router>
          <AppRoutes />
        </Router>
      </DarkModeWrapper>
    </StoreProvider>
  );
}

export default App;
